import { render, staticRenderFns } from "./ZensocialLanding.vue?vue&type=template&id=f77e348e"
import script from "./ZensocialLanding.vue?vue&type=script&lang=js"
export * from "./ZensocialLanding.vue?vue&type=script&lang=js"
import style0 from "./ZensocialLanding.vue?vue&type=style&index=0&id=f77e348e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports